// src/lib/roleLive.ts
import { openWS } from "./ws";
import { api } from "./api";
import { ROUTE } from "./paths";

let ws: WebSocket | null = null;

export function startRoleWatcher() {
  if (ws) return;
  ws = openWS(async (m) => {
    if (m?.type === "role_change") {
      try {
        const me = await api.me();
        const role = (me.role || "").toLowerCase();
        // простая маршрутизация
        if (["admin","superadmin"].includes(role)) {
          if (!location.pathname.startsWith(ROUTE.toPath(ROUTE.super()))) {
            location.replace(ROUTE.toPath(ROUTE.super()));
          }
        } else if (["staff","door"].includes(role)) {
          if (!location.pathname.startsWith("/door")) {
            location.replace(ROUTE.toPath(ROUTE.door()));
          }
        } else {
          if (!location.pathname.startsWith(ROUTE.toPath(ROUTE.guest()))) {
            location.replace(ROUTE.toPath(ROUTE.guest()));
          }
        }
      } catch {}
    }
  });
}